import { User } from '@biniyog/models';
import decode from 'jwt-decode';

export const getUserFromAccessToken = (token: string) => {
  return decode(token) as Partial<User>;
};
